import { Component, input, output, signal } from '@angular/core';

import { CloseIconButtonComponent } from '@sandbox-platform/shared-ui';
import { OrganizationSummaryDTO } from '../types/organization.types';

@Component({
  standalone: true,
  imports: [CloseIconButtonComponent],
  selector: 'lib-organization-filter',
  template: `
    <div>
      <label
        for="organization-filter"
        class="block text-sm font-medium text-gray-700 mb-2"
      >
        Organization
      </label>
      @if (selectedOrganization()) {
      <div
        class="flex items-center justify-between w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 h-[42px] gap-x-2"
      >
        <div
          class="flex items-center flex-1 min-w-0 cursor-pointer"
          (click)="openOrganizationSearch()"
        >
          <div class="flex-shrink-0 h-6 w-6">
            <div
              class="h-6 w-6 rounded-full bg-orange-100 flex items-center justify-center text-orange-600 font-medium text-xs"
            >
              {{ getOrganizationInitials(selectedOrganization()!) }}
            </div>
          </div>
          <div class="ml-3 flex-1 min-w-0">
            <div class="text-sm text-gray-800 truncate">
              {{ selectedOrganization()!.name }}
            </div>
          </div>
        </div>

        <lib-close-icon-button
          size="sm"
          variant="modal"
          title="Clear organization filter"
          ariaLabel="Clear organization filter"
          (clicked)="onResetOrganizationFilter()"
        />
      </div>
      } @else {
      <button
        id="organization-filter"
        type="button"
        (click)="openOrganizationSearch()"
        class="w-full px-3 py-2 border border-gray-300 text-sm rounded-md text-left text-gray-500 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 h-[42px]"
      >
        All Organizations
      </button>
      }
    </div>
  `,
})
export class OrganizationFilterComponent {
  // Internal state
  protected selectedOrganization = signal<OrganizationSummaryDTO | null>(null);

  // Output signals
  openOrganizationModal = output<void>();
  organizationFilterChange = output<string>();

  // Organization search modal methods
  openOrganizationSearch(): void {
    console.log('Organization search button clicked');
    this.openOrganizationModal.emit();
    console.log('openOrganizationModal event emitted');
  }

  // Method to set selected organization (called from parent)
  setSelectedOrganization(organization: OrganizationSummaryDTO | null): void {
    this.selectedOrganization.set(organization);
    this.organizationFilterChange.emit(organization?.id || '');
  }

  getOrganizationInitials(organization: OrganizationSummaryDTO): string {
    const words = organization.name.split(' ');
    if (words.length >= 2) {
      return `${words[0].charAt(0).toUpperCase()}${words[1]
        .charAt(0)
        .toUpperCase()}`;
    }
    return organization.name.charAt(0).toUpperCase();
  }

  onResetOrganizationFilter(): void {
    this.selectedOrganization.set(null);
    this.organizationFilterChange.emit('');
  }

  // Method to reset internal state (called from parent)
  reset(): void {
    this.selectedOrganization.set(null);
  }

  // Getter for selected organization (for parent access)
  getSelectedOrganization(): OrganizationSummaryDTO | null {
    return this.selectedOrganization();
  }
}
